import { useEffect } from "react";

interface ConfirmModalProps {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export default function ConfirmModal({
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
  onConfirm,
  onClose,
}: ConfirmModalProps) {
  useEffect(() => {
    function handleKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  function handleConfirm() {
    onConfirm();
    onClose();
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.55)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        padding: 24,
        animation: "modalBackdropIn 0.15s ease",
      }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        style={{
          background: "rgba(12, 12, 12, 0.97)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          borderRadius: 6,
          padding: "28px 32px",
          maxWidth: 440,
          width: "100%",
          boxShadow: "0 32px 80px rgba(0,0,0,0.75), inset 0 1px 0 rgba(255,255,255,0.05)",
          animation: "modalCardIn 0.2s cubic-bezier(0.34, 1.4, 0.64, 1)",
        }}
      >
        <h2 style={{ margin: "0 0 10px", fontSize: 17, fontWeight: 700, color: "#EFF2F5", letterSpacing: "-0.01em" }}>
          {title}
        </h2>
        <p style={{ margin: "0 0 26px", fontSize: 14, color: "#98A1AB", lineHeight: 1.65, whiteSpace: "pre-wrap" }}>
          {message}
        </p>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button
            onClick={onClose}
            className="btn-glass"
            style={{ padding: "8px 18px", fontSize: 13 }}
          >
            {cancelLabel}
          </button>
          <button
            onClick={handleConfirm}
            className={destructive ? undefined : "btn-primary"}
            style={{
              padding: "8px 18px",
              fontSize: 13,
              fontWeight: 600,
              borderRadius: 3,
              cursor: "pointer",
              fontFamily: "inherit",
              ...(destructive ? {
                background: "rgba(255, 92, 92, 0.1)",
                color: "#FF5C5C",
                border: "1px solid rgba(255, 92, 92, 0.35)",
              } : {
                border: undefined,
              }),
            }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
